<div class="container py-5 px-0 mt-4">
    <div class="w-100 d-flex justify-content-between align-items-start">
        <button (click)="endQuiz()" class="end-quiz-btn text-16-600-150">
            {{'End quiz'| translate}}
        </button>
        <div class="text-36-600-119 text-c4">
            <span class="d-flex align-items-start gap-4">
                {{'Leaderboard' | translate}}
                <img src="assets/icons/bars.svg" alt="">
            </span>
            <div *ngIf="canShowTimer" style="min-height: 7.2rem;" class="counter w-100 mt-5 d-flex justify-content-center align-items-center gap-4">
                <div *ngIf="quizStarted" class="h-100 w-100 d-flex flex-column gap-5 align-items-center justify-content-center">
                    <!-- <p class="text-96-500-83 text-c3 mb-0">{{'3'}}</p> -->
                    <div *ngIf="activeNumber !== null" [@slideUpAnimation] class="text-32-600-125 text-c3 mb-0 position-absolute">
                        {{ activeNumber }}
                      </div>
                </div>
                <ng-container *ngIf="!quizStarted">
                    <img src="assets/icons/stopwatch.svg" alt="">
                    <span *ngIf="!isTimeUp" class="text-32-600-125 text-c4">{{timeRemaining}}</span>
                    <span class="text-28-600-128 text-c2" *ngIf="isTimeUp">{{'Time’s Up!' | translate}}</span>
                </ng-container>
            </div>
        </div>
        <button [ngClass]="{'p-e-none': disablePopUp}" (click)="showQrCode()" class="qr-btn d-flex align-items-center gap-3 text-18-500-150 text-c2">
            <img src="assets/icons/qr-icon.svg" alt="">
            {{'QR Code' | translate}}
        </button>
    </div>

    <div *ngIf="leaderboard" class="mt-5 pt-3 d-flex justify-content-center">
        <table class="mytable">
            <thead>
              <tr>
                <th>{{'No.'| translate}}</th>
                <th>{{'Team' | translate}}</th>
                <th>{{'Team code' | translate}}</th>
                <th>{{'Questions completed' | translate}}</th>
                <th>{{'Score' | translate}}</th>
              </tr>
            </thead>
            <tbody *ngIf="leaderboard?.teams">
              <tr *ngFor="let team of leaderboard.teams; let i = index">
                <td class="text-24-600-116 text-c2">{{ i + 1 }}</td>
                <td class="text-24-600-133 text-c4">{{ team.name }}</td>
                <td class="text-24-500-116 text-c4">{{ team.team_code }}</td>
                <td>
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" [style.width.%]="team.completed_percentage"
                        aria-valuenow="12" aria-valuemin="0" aria-valuemax="100">
                        </div>
                    </div>
                </td>
                <td class="text-36-600-88 text-c4">
                    <span>{{team.score}}</span>
                    <!-- <img *ngIf="team?.up" src="assets/icons/up-green.svg" alt=""> -->
                </td>
              </tr>
            </tbody>
          </table>
    </div>
</div>